import React from 'react'
import styles from './contact-us-tiles.module.scss';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import FaxIcon from '@mui/icons-material/Fax';
import {Box} from "@mui/material";
import {TikTokIcon} from "@/ui/tiktok-icon/tiktokIcon";
import YouTubeIcon from '@mui/icons-material/YouTube';
import {socialMediaProfiles, contactDetails, BUSINESS_NAME} from "@/content";
import Typography from "@mui/material/Typography";


type ContactUsProps = {
    showSocials?: boolean;
    hidePhone?: boolean;
    hideLabels?: boolean;
}




const ContactUsTiles = ({showSocials = false, hidePhone = true}: ContactUsProps) => {

    const {
        contactNumberOne,
        contactNumberTwo,
        contactEmail,
        fax
    } = contactDetails;

    const {
        facebookHandle,
        tikTokHandle,
        instaHandle,
        youTubeHandle,
        facebookLink = 'https://www.facebook.com/',
        tikTokLink = 'https://www.tiktok.com/@',
        instaLink = 'https://www.instagram.com/',
        youTubeLink = 'https://www.youtube.com/user'
    } = socialMediaProfiles;



//todo get this out

    const renderSocialBlock = (
        IconComponent: React.ElementType,
        label: string,
        link: string,
        handle: string | undefined
    ) => {
        if (!handle) return null;

        return (
            <div className='flex gap-[10px]'>
                <div className={styles.contactIcon}>
                    <IconComponent />
                </div>
                <div>
                    <a href={`${link}${handle}`} className='text-[20px]'  target="_blank" rel="nofollow">
                        {label}
                    </a>
                </div>
            </div>
        );
    };

    const socialsBlock = (
        <>
            {renderSocialBlock(FacebookIcon, 'Facebook', facebookLink, facebookHandle)}
            {renderSocialBlock(TikTokIcon, 'TikTok', tikTokLink, tikTokHandle)}
            {renderSocialBlock(InstagramIcon, 'Instagram', instaLink, instaHandle)}
            {renderSocialBlock(YouTubeIcon, 'YouTube', youTubeLink, youTubeHandle)}
        </>
    );


    const renderContactBlock = (
        IconComponent: React.ElementType,
        label: string,
        linkPrefix: string,
        content: string,
        secondaryContent?: string
    ) => {
        if (!content) return null;

        return (
            <Box className={styles.contactBlock} sx={(theme) => ({
                '&>a': { color: theme.palette.text.primary }
            })}>
                <div className={styles.contactIcon}>
                    <IconComponent />
                </div>
                <Box className={styles.contactContent} sx={(theme) => ({
                    '&>a': { color: theme.palette.text.primary }
                })}>
                    <a href={`${linkPrefix}${content}`} title={label}>{label}: {content}</a>
                    {secondaryContent && (
                        <span> OR <a href={`${linkPrefix}${secondaryContent}`}>{secondaryContent}</a></span>
                    )}
                </Box>
            </Box>
        );
    };

// Replace repetitive blocks with the reusable function
    const contactBlock =
        <Box>
            <div className={styles.contactUsTileContainer}>
                {!hidePhone && contactNumberOne && renderContactBlock(
                    PhoneAndroidIcon,
                    'Phone',
                    'tel:',
                    contactNumberOne,
                    contactNumberTwo
                )}
                {!hidePhone && contactNumberOne && renderContactBlock(
                    SmsIcon,
                    'SMS',
                    'sms:',
                    contactNumberOne,
                    contactNumberTwo
                )}
                {!hidePhone && fax && renderContactBlock(
                    FaxIcon,
                    'FAX',
                    'fax:',
                    fax,
                )}
                {contactEmail && renderContactBlock(
                    EmailIcon,
                    'Email',
                    'mailto:',
                    contactEmail
                )}
            </div>
        </Box>;

    return (
        <div className="flex flex-col md:flex-row items-start content-start justify-between gap-[20px]">
            <div>
                <Typography variant='h5' className="block md:hidden">
                    Contact {BUSINESS_NAME} today
                </Typography>
                {contactBlock}
            </div>
            {
                !!showSocials &&
                (
                    <div className='py-[20px]'>
                        <Typography variant='h5' className="block md:hidden">
                            Follow {BUSINESS_NAME} on socials
                        </Typography>
                        {socialsBlock}
                    </div>
                )
            }
        </div>

    )
}
export default ContactUsTiles
